import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { byProductDisplayOrder, MAGAZINE_GROUP_CODE } from 'eds-common';
import {
  fetchApplications,
  type Application,
} from '@/services/composite-service/composite-service';

const byApplicationDisplayOrder = byProductDisplayOrder<Application>({
  name: (application) => application.applicationTitle,
  isMagazine: (application) => application.groupCode === MAGAZINE_GROUP_CODE,
});

export function applicationsQuery() {
  return {
    queryKey: ['applications'],
    queryFn: () => fetchApplications(),
  } satisfies UseQueryOptions;
}

export function useApplications() {
  return useQuery({
    ...applicationsQuery(),
    select: (applications: Application[]) =>
      [...applications].sort(byApplicationDisplayOrder),
  });
}
